module.exports = __webpack_public_path__ + "static/icon-refresh.8cf8b702.png";